import { useState } from "react";
import { Info } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

const SECTIONS = [
  ["1. Inscription et profil", [
    "Nom du restaurant, logo, photo de couverture",
    "Adresse géolocalisée sur la carte WÔMA",
    "Numéro de téléphone, email de contact",
    "Catégorie (Sénégalais, Fast-food, Grillades, Pizzeria, etc.)",
    "Horaires d'ouverture par jour",
    "Statut : Ouvert / Fermé (activable manuellement)",
  ]],
  ["2. Gestion du menu", [
    "Création de catégories personnalisées (Entrées, Plats, Desserts, Boissons, Spécialités, etc.)",
    "Chaque plat : photo, nom, description, prix en FCFA",
    "Activation / désactivation d'un plat sans le supprimer",
    "Mise à jour du menu en temps réel",
  ]],
  ["3. Réception des commandes", [
    "Notification WhatsApp à chaque nouvelle commande",
    "Tableau de bord avec statuts : Nouvelle / En préparation / Prête / Livrée",
    "Détail de chaque commande : plats, adresse de livraison, mode de paiement, montant total",
  ]],
  ["4. Tarification et commissions", [
    "Frais d'inscription : 5 000 FCFA avec 3 mois gratuits offerts",
    "À partir du 4ème mois : abonnement mensuel de 1 000 FCFA",
    "Solde minimum 1 000 FCFA pour rester visible",
    "10% de commission déduits sur chaque commande livrée",
    "Historique des transactions visible sur le tableau de bord",
    "Rechargement via Wave",
  ]],
  ["5. Livraison", [
    "Assignation automatique d'un livreur WÔMA disponible à proximité",
    "Suivi GPS de la livraison en temps réel pour le restaurant et le client",
    "Frais de livraison : 1 000 FCFA (fixe)",
  ]],
  ["6. Visibilité côté client", [
    "Affiché sur la section Food avec logo, note, temps de livraison estimé",
    "Recherche par nom ou catégorie",
    "Affichage sur la carte WÔMA avec localisation exacte",
  ]],
];

// Bouton « i » : fiche partenaire restaurant WÔMA
export const RestaurantInfoButton = ({ className = "", label = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-label="Fiche partenaire restaurant"
        className={`inline-flex items-center gap-2 rounded-full bg-[#D4AF37] text-[#0F172A] font-black shadow-lg shadow-[#D4AF37]/30 ${label ? "px-4 py-2 text-[11px] uppercase tracking-widest" : "w-9 h-9 justify-center"} ${className}`}
        data-testid="restaurant-info-btn">
        <Info size={18} strokeWidth={3} />{label && "Fiche restaurant"}
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto bg-[#0B1220] border-white/10 text-white" data-testid="restaurant-info-sheet">
          <SheetHeader>
            <SheetTitle className="text-white text-left">FICHE PARTENAIRE RESTAURANT — WÔMA</SheetTitle>
            <SheetDescription className="text-slate-400 text-left">Tout ce qu'il faut savoir pour vendre vos plats sur WÔMA.</SheetDescription>
          </SheetHeader>
          <div className="mt-6 space-y-6">
            {SECTIONS.map(([title, items]) => (
              <section key={title} className="space-y-2">
                <h3 className="text-xs font-black uppercase tracking-widest text-[#D4AF37]">{title}</h3>
                <ul className="space-y-1.5 text-sm text-slate-200">
                  {items.map((it) => <li key={it} className="flex gap-2"><span className="text-[#D4AF37]">•</span>{it}</li>)}
                </ul>
              </section>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
